import { Link, useSearch } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { Button } from '../components/ui/button.tsx';
import { HelpButton, useHelpPage } from '../help/help.tsx';

export function AccessDeniedPage() {
  const { t } = useTranslation();
  useHelpPage('accessDenied');
  const { reason } = useSearch({ strict: false }) as { reason?: string };
  const text = reason === 'disabled' ? t('errors.auth.disabled') : t('errors.auth.not_member');
  return (
    <div className="flex min-h-dvh items-center justify-center px-4">
      <main className="max-w-md rounded-xl border border-border bg-card p-6 text-center">
        <div className="mb-3 flex items-center justify-between gap-4">
          <h1 className="text-2xl">{t('accessDenied.title')}</h1>
          <HelpButton />
        </div>
        <p className="mb-6 text-muted-foreground">{text}</p>
        <Button asChild variant="outline" data-help-id="accessDenied.back">
          <Link to="/sign-in">{t('accessDenied.back')}</Link>
        </Button>
      </main>
    </div>
  );
}
